import gql from 'graphql-tag';
const Q_AND_A_ACTIVITY_FRAGMENT = gql `
  fragment QandAActivityFragment on QandAActivity {
    rounds {
      contentImage {
        id
        image {
          description
          id
          src
        }
      }
      steps {
        id
        question
        answer
      }
    }
  }
`;
export default Q_AND_A_ACTIVITY_FRAGMENT;
